<form [formGroup]="searchItem" class="filterable-list">
  <input #input [ngClass]="{'active': showList}" [placeholder]="getPlaceholder()" (keydown.arrowup)="select(true)" (keydown.arrowdown)="select(false)" (keydown.enter)="selectItemEnter()" (click)="startComponent()" formControlName="des">
  <span *ngIf="!searchItem.disabled" class="enabled">
    <i [ngClass]="showList ? 'fas fa-angle-up': 'fas fa-angle-down'" 
       (click)="searchItem.disabled ? $event.stopPropagation() : showList=!showList; input.focus();"></i>
  </span>
  <span *ngIf="searchItem.disabled" class="disabled">
    <i [ngClass]="showList ? 'fas fa-angle-up': 'fas fa-angle-down'" 
       (click)="searchItem.disabled ? $event.stopPropagation() : showList=!showList; input.focus();"></i>
  </span>
  <content *ngIf="showList">
    <!-- <li *ngIf="selectedItem.value" class="selected">{{selectedItem.value.des}}
      <i class="fas fa-times" (click)="reset()"></i></li> -->
    <ng-container *ngFor="let item of filteredList; let i = index;">
      <li id= "item{{i}}" [ngClass]="{'active': i == selected}" [class.selected]="i == selected" (click)="selectItem(item)" tabIndex="-1">
        {{item.des}}
        <i *ngIf="selectedItem.value && item.des === selectedItem.value.des" class="fas fa-times" (click)="reset($event)"></i></li>
    </ng-container>
    <li *ngIf="filteredList && filteredList.length === 0">{{ 'global.noContent' | translate }}</li>
  </content>
</form>
